export default "__VITE_ASSET__09e1bec9__"